import { apiRequest } from './client.js';
import type { AppConfig } from '@hisob/types';

export async function fetchAppConfig(): Promise<AppConfig> {
  return apiRequest<AppConfig>('/api/v1/admin/config');
}

export async function updateAppConfig(payload: {
  min_supported_version: string;
  latest_version: string;
  force_update: boolean;
  android_url?: string | null;
  ios_url?: string | null;
  changelog?: string | null;
  maintenance_mode: boolean;
  maintenance_message?: string | null;
}): Promise<AppConfig> {
  return apiRequest<AppConfig>('/api/v1/admin/config', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

